module.exports = __webpack_public_path__ + "static/media/warrantyPartial.73dbf54e.svg";